import advanceCollectionActionTypes from './advance-collection.types';

/** ***************** GET MEMBER LOAN INFO START *********************** */
export const fetchAdvanceMemberLoanInfoStart = (getData: any) => ({
	type: advanceCollectionActionTypes.GET_ADVANCE_MEMBER_LOAN_LIST_START,
	payload: getData,
});

export const fetchAdvanceMemberLoanInfoSuccess = (successData: any) => ({
	type: advanceCollectionActionTypes.GET_ADVANCE_MEMBER_LOAN_LIST_SUCCESS,
	payload: successData,
});

export const fetchAdvanceMemberLoanInfoFailure = (failureData: any) => ({
	type: advanceCollectionActionTypes.GET_ADVANCE_MEMBER_LOAN_LIST_FAILURE,
	payload: failureData,
});

export const fetchAdvanceMemberLoanInfoResponseResetStart = () => ({
	type: advanceCollectionActionTypes.GET_ADVANCE_MEMBER_LOAN_LIST_RESPONSE_RESET,
});

export const fetchAdvanceMemberLoanInfoResponseChanged = () => ({
	type: advanceCollectionActionTypes.GET_ADVANCE_MEMBER_LOAN_LIST_RESPONSE_CHANGED,
});
/** ***************** GET MEMBER LOAN INFO END *********************** */

/** ***************** UPDATE ADVANCE COLLECTION START *********************** */
export const updateAdvanceCollectionStart = (getData: any) => ({
	type: advanceCollectionActionTypes.UPDATE_ADVANCE_COLLECTION_START,
	payload: getData,
});

export const updateAdvanceCollectionSuccess = (successData: any) => ({
	type: advanceCollectionActionTypes.UPDATE_ADVANCE_COLLECTION_SUCCESS,
	payload: successData,
});

export const updateAdvanceCollectionFailure = (failureData: any) => ({
	type: advanceCollectionActionTypes.UPDATE_ADVANCE_COLLECTION_FAILURE,
	payload: failureData,
});

export const updateAdvanceCollectionResponseResetStart = () => ({
	type: advanceCollectionActionTypes.UPDATE_ADVANCE_COLLECTION_RESPONSE_RESET,
});

export const updateAdvanceCollectionResponseChanged = () => ({
	type: advanceCollectionActionTypes.UPDATE_ADVANCE_COLLECTION_RESPONSE_CHANGED,
});
/** ***************** UPDATE ADVANCE COLLECTION END *********************** */
